export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "delete_confirm_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["삭제를 확인하시겠습니까?"])}
    }
  })
}
